// extracted by mini-css-extract-plugin
export default {"mainContainer":"newTrackButton_mainContainer__pccV+","newTrackButton":"newTrackButton_newTrackButton__SoU8-"};